import { jsx as _jsx } from "react/jsx-runtime";
import { ShowBase } from "react-admin";
import { ContestTabs } from "./ContestTabs";
export var ContestBaseTabs = function () {
    return (_jsx(ShowBase, { children: _jsx(ContestTabs, {}) }));
};
